<template>
  <div id="app">
    <!-- <div class="the_recruit_tite_img_body">
      <img class="the_recruit_tite_img" src="@/assets/img/Meeting-Room-02.jpg?v=1.0.0.1" />
    </div> -->
    <waveHeader :bg="'type_3'" pathName="recruit"></waveHeader>
    <div class="the_recruit_body common_body" data-aos="fade-right">
      <h2 class="the_recruit_h2 tc">採用情報</h2>
      <h5 class="the_recruit_h5 tc mb20">Recruit</h5>
      <div>
        <el-row :gutter="24">
          <el-col :span="12">
            <div class="the_recruit_top_menu_body" :class="{active:active===0}" @click="active=0">
              <div>
                <h6 class="the_recruit_h6_big pt10 tc">新卒</h6>
                <h6 class="the_recruit_h6_sm tc pb10">New grad</h6>
                <el-row :gutter="24" class="mt20 the_recruit_top_menu_row">
                  <el-col :span="12">
                    <img class="the_recruit_top_menu_img" src="@/assets/img/recruit1.png?v=1.0.0.1" />
                  </el-col>
                  <el-col :span="12">
                    <p class="the_recruit_top_menu_text">THEでは、システムエンジニアを目指す方を求めています。全学部・全学科からの募集で、社員の半数以上が文系出身、プログラミング未経験者です。ITのスペシャリストへ成長できる環境をご用意して、お待ちしています。</p>
                  </el-col>
                </el-row>
              </div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="the_recruit_top_menu_body" :class="{active:active===1}" @click="active=1">
              <div>
                <h6 class="the_recruit_h6_big pt10 tc">中途</h6>
                <h6 class="the_recruit_h6_sm tc pb10">Mid career</h6>
                <el-row :gutter="24" class="mt20 the_recruit_top_menu_row">
                  <el-col :span="12">
                    <img class="the_recruit_top_menu_img" src="@/assets/img/recruit0.png?v=1.0.0.1" />
                  </el-col>
                  <el-col :span="12">
                    <p class="the_recruit_top_menu_text">THEでは、システムエンジニア、プログラマーの経験者を求めています。既にお持ちの技術や経験を是非弊社で活かしてみませんか？働きながら技術の向上を図りたいという向上心のある方のご応募をお待ちしております。</p>
                  </el-col>
                </el-row>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="the_recruit_content_body" v-show="active===0">
        <div>
          <h2 class="the_recruit_h2 tc">新卒採用情報</h2>
          <h5 class="the_recruit_h5 tc mb20">New graduates</h5>
          <div>
            <table class="the_recruit_table" data-aos="fade-right">
              <tbody>
                <tr>
                  <td class="the_recruit_title_td"><div>募集職種</div></td>
                  <td><div>システムエンジニア</div></td>
                </tr>
                <tr>
                  <td class="the_recruit_title_td"><div>募集人数</div></td>
                  <td><div>東京10名</div></td>
                </tr>
                <tr>
                  <td class="the_recruit_title_td"><div>募集学科</div></td>
                  <td>
                    <div>
                      全学部・全学科<br />
                      ★社員の半数以上が文系出身・プログラミング未経験者です
                    </div>
                  </td>
                </tr>
                <tr>
                  <td class="the_recruit_title_td"><div>資格</div></td>
                  <td>
                    <div>新卒 {{(new Date().getFullYear())}}年3月卒業見込みの方<br /> 既卒 卒業後3年以内の方</div>
                  </td>
                </tr>
                <tr>
                  <td class="the_recruit_title_td"><div>初任給</div></td>
                  <td><div>大学院：213,000円<br />
                            四大卒：206,000円<br />
                            専門卒：181,200円（2年の場合）</div></td>
                </tr>
                <tr>
                  <td class="the_recruit_title_td"><div>募集職種</div></td>
                  <td><div>システムエンジニア</div></td>
                </tr>
                <tr>
                  <td class="the_recruit_title_td"><div>諸手当</div></td>
                  <td><div>通勤手当、時間外手当、出張手当、家族手当、資格手当、役職手当など</div></td>
                </tr>
                <tr>
                  <td class="the_recruit_title_td"><div>昇給</div></td>
                  <td><div>年1回（4月）</div></td>
                </tr>
                <tr>
                  <td class="the_recruit_title_td"><div>賞与</div></td>
                  <td><div>年2回（7月、1月）</div></td>
                </tr>
                <tr>
                  <td class="the_recruit_title_td"><div>福利厚生</div></td>
                  <td><div>厚生年金保険、雇用保険、労災保険<br />
                    確定拠出年金制度(選択制)<br />
                            永年勤続報奨制度 等々</div></td>
                </tr>
                <tr>
                  <td class="the_recruit_title_td"><div>休日・休暇</div></td>
                  <td><div>完全週休二日制(土、日、祝日)<br />
                            年末年始休暇(12月30日～1月3日)<br />
                            年次有給休暇<br />
                            育児休暇<br />
                            介護休暇<br />
                            当社規程により特別休暇（慶弔）など</div></td>
                </tr>
                <tr>
                  <td class="the_recruit_title_td"><div>勤務地</div></td>
                  <td><div>原則 採用拠点(東京)での 勤務となります<br />
                            ※案件により取引先企業にて、開発業務を行う場合もあります<br />
                            主な常駐エリア<br />
                          ・東京：本社及び首都圏(東京・神奈川)</div></td>
                </tr>
                <tr>
                  <td class="the_recruit_title_td"><div>勤務時間</div></td>
                  <td><div>東京 9：30～18：30（実働 8時間）</div></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="mt30">
          <h2 class="the_recruit_h2 tc">新卒採用先行ステップ</h2>
          <h5 class="the_recruit_h5 tc mb20">Recruit sept</h5>
          <div class="the_recruit_step_body">
            <div class="the_recruit_step_body">
              <div data-aos="fade-right">
                <div class="the_recruit_step_title">STEP.1 エントリー</div>
                <div class="the_recruit_step_content">以下マイナビサイトよりエントリーお願いします。</div>
              </div>
              <div class="tc f20"><i class="el-icon-caret-bottom"></i></div>
              <div data-aos="fade-right">
                <div class="the_recruit_step_title">STEP.2 会社説明会</div>
                <div class="the_recruit_step_content">会社説明：会社の概略をご説明いたします。<br />仕事説明：システム業界の仕事を具体的にご説明します。</div>
              </div>
              <div class="tc f20"><i class="el-icon-caret-bottom"></i></div>
              <div data-aos="fade-right">
                <div class="the_recruit_step_title">STEP.3 面接試験</div>
                <div class="the_recruit_step_content">採用担当との面接試験。履歴書やエントリーシートの確認が中心の個人面接となります。</div>
              </div>
              <div class="tc f20"><i class="el-icon-caret-bottom"></i></div>
              <div data-aos="fade-right">
                <div class="the_recruit_step_title">STEP.4 最終面接</div>
                <div class="the_recruit_step_content">開発部門責任者との面接試験。志望動機、将来像等の質問が中心となります。</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="the_recruit_content_body" v-show="active===1">
        <div>
          <h2 class="the_recruit_h2 tc">キャリア採用情報</h2>
          <h5 class="the_recruit_h5 tc mb20">Mid career hire</h5>
          <div data-aos="fade-right">
            <table class="the_recruit_table">
              <tbody>
                <tr>
                  <td class="the_recruit_title_td"><div>雇用形態</div></td>
                  <td><div>正社員</div></td>
                </tr>
                <tr>
                  <td class="the_recruit_title_td"><div>募集職種</div></td>
                  <td><div>システムエンジニア、リーダー、プログラマー</div></td>
                </tr>
                <tr>
                  <td class="the_recruit_title_td"><div>職務内容</div></td>
                  <td>
                    <div>
                      ①Java、PHP、.Net、Python、Nodejs、PL/SQL等を使用したシステムの設計・開発<br />
                      ②プロジェクトマネージメント
                    </div>
                  </td>
                </tr>
                <tr>
                  <td class="the_recruit_title_td"><div>必要な経験</div></td>
                  <td>
                    <div>①Java、PHP、.Net、Python、Nodejs、PL/SQL<br />
                    ②各種DB設計(Oracle、SQL Server、DB2、MySQL)</div>
                  </td>
                </tr>
                <tr>
                  <td class="the_recruit_title_td"><div>望ましい経験</div></td>
                  <td><div>プロジェクトリーダー経験 Android、iPhone、iPad 開発経験 フレームワーク経験</div></td>
                </tr>
                <tr>
                  <td class="the_recruit_title_td"><div>学歴</div></td>
                  <td><div>不問</div></td>
                </tr>
                <tr>
                  <td class="the_recruit_title_td"><div>勤務地</div></td>
                  <td><div>東京本社（東京都中央区）、その他顧客先（都内各地）</div></td>
                </tr>
                <tr>
                  <td class="the_recruit_title_td"><div>勤務時間</div></td>
                  <td><div>①弊社事業所の場合／9:30～18:30
                    <br />②お客様事業所の場合／お客様環境による</div></td>
                </tr>
                <tr>
                  <td class="the_recruit_title_td"><div>面接場所</div></td>
                  <td><div>東京本社<br />
                              〒123-0852 東京都足立区関原2一2一27</div></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="mt30">
          <h2 class="the_recruit_h2 tc">キャリア採用先行ステップ</h2>
          <h5 class="the_recruit_h5 tc mb20">Recruit step</h5>
          <div class="the_recruit_step_body">
            <div class="the_recruit_step_body">
              <div data-aos="fade-right">
                <div class="the_recruit_step_title">STEP.1 応募</div>
                <div class="the_recruit_step_content">応募まずは電話、メールでご連絡いただいた上で郵送またはメール送信で応募書類を提出してください。</div>
              </div>
              <div class="tc f20"><i class="el-icon-caret-bottom"></i></div>
              <div data-aos="fade-right">
                <div class="the_recruit_step_title">STEP.2 書類選考</div>
                <div class="the_recruit_step_content">書類選考を行います。</div>
              </div>
              <div class="tc f20"><i class="el-icon-caret-bottom"></i></div>
              <div data-aos="fade-right">
                <div class="the_recruit_step_title">STEP.3 一次面接</div>
                <div class="the_recruit_step_content">人物重視で選考を行います。どんなことでもお気軽にお話しください。</div>
              </div>
              <div class="tc f20"><i class="el-icon-caret-bottom"></i></div>
              <div data-aos="fade-right">
                <div class="the_recruit_step_title">STEP.4 条件面談 二次面談</div>
                <div class="the_recruit_step_content">採用条件等の提示面談を実施します。現場担当者による詳細な技術内容の確認面談を行う場合もあります。</div>
              </div>
            </div>
          </div>
        </div>
        <div class="mt30">
          <h2 class="the_recruit_h2 tc">エントリー</h2>
          <h5 class="the_recruit_h5 tc mb20">entry</h5>
          <el-row :gutter="24">
            <el-col :lg="12">
              <div class="the_recruit_window_body" data-aos="fade-right">
                <div class="the_recruit_window_title"><i class="el-icon-s-promotion"></i>フォームからの応募はこちらから</div>
                <div class="the_recruit_window_content" data-aos="fade-right">
                  送信先：<a href="mailto:support@the.co.jp">support@the.co.jp</a><br />
                  携帯電話/Mail等のご連絡先をご記入ください<br />
                  不明な点がございましたらご連絡ください<br />
                  <a href="/contact">お問い合わせフォーム</a>
                </div>
              </div>
            </el-col>
            <el-col :lg="12">
              <div class="the_recruit_window_body" data-aos="fade-right">
                <div class="the_recruit_window_title"><i class="el-icon-phone"></i>お電話からの応募はこちらから</div>
                <div class="the_recruit_window_content" data-aos="fade-right">
                  個人情報取扱いの苦情申し出先<br />
                  管理部（苦情相談窓口責任者）<br />
                  TEL：<a href="tel:03-6432-0234">03-6432-0234</a><br />
                  会社名称：THEグローバルシステム株式会社メール<br />
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <commonFooter></commonFooter>
  </div>
</template>

<script>
import commonFooter from '../../../components/footer.vue'
import waveHeader from '../../../components/waveHeader.vue'
export default {
  data() {
    return {
      active: 0
    }
  },
  components: {
    waveHeader,
    commonFooter
  },
  mounted() {},
  methods: {}
}
</script>

<style scoped>
.el-icon-s-promotion,
.el-icon-phone {
  font-size: 18px !important;
}
.the_recruit_tite_img_body {
  padding-top: 80px;
  text-align: center;
}
.the_recruit_body {
  padding-top: 0px;
}
.the_recruit_h2 {
  font-size: 22px;
  font-weight: bold;
}
.the_recruit_h5 {
  font-size: 14px;
}
.the_recruit_h4 {
  font-size: 24px;
  padding-bottom: 8px;
  border-bottom: 2px solid #202020;
  margin-bottom: 30px;
}
.the_recruit_sm_title {
  font-weight: bold;
  line-height: 32px;
}
.the_recruit_sm_content {
  line-height: 32px;
}
.the_recruit_box {
  padding-bottom: 80px;
}
.the_recruit_tite_img {
  max-width: 100%;
}
.the_recruit_top_menu_body {
  border-radius: 5px;
  background-color: rgba(255, 255, 255);
  box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.2);
  min-height: 300px;
  text-align: center;
  padding: 0 26px;
  margin-bottom: 20px;
  transition: all 0.5s;
  cursor: pointer;
  position: relative;
}
.the_recruit_top_menu_body:not(.active):hover {
  transform: translateY(-10px);
}
.the_recruit_top_menu_body.active {
  background-image: linear-gradient(45deg, #6859ea 0, #6acbe0 100%);
  color: #fff;
  cursor: default;
}
.the_recruit_h6_big {
  font-size: 18px;
}
.the_recruit_h6_sm {
  font-size: 14px;
}
.the_recruit_top_menu_img {
  width: 100%;
  height: auto;
}
.the_recruit_top_menu_text {
  text-align: left;
  font-size: 14px;
  padding-top: 20px;
  line-height: 28px;
}
.the_recruit_table,
.the_recruit_step_table {
  width: 100%;
}
.the_recruit_table td,
.the_recruit_step_table td {
  line-height: 32px;
  border: 1px solid #ccc;
  padding: 10px;
  min-width: 74px;
}
.the_recruit_title_td,
.the_recruit_step {
  text-align: center;
  background-color: #f8f8f8;
}
.the_recruit_step {
  border-right: none !important;
}
.the_recruit_step_dec {
  border-left: none !important;
}
.the_recruit_content_body {
  margin-top: 30px;
  margin-bottom: 30px;
}
.the_recruit_step_body {
  margin-top: 30px;
}
.the_recruit_step_title {
  width: 35%;
  border-radius: 40px;
  height: 40px;
  line-height: 40px;
  font-size: 16px;
  text-align: center;
  background-image: linear-gradient(45deg, #6859ea 0, #6acbe0 100%);
  color: #fff;
  margin: 0 auto;
  box-sizing: border-box;
  min-width: 240px;
  position: relative;
  z-index: 2;
}
.the_recruit_step_content {
  width: 100%;
  border-radius: 20px;
  color: #367ce4;
  text-align: center;
  margin: 0 auto;
  padding: 30px 20px 20px 20px;
  margin-top: -20px;
  box-sizing: border-box;
  z-index: 1;
  position: relative;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.4);
}
.the_recruit_window_body {
  /* border: 2px solid #367ce4; */
  box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.2);
}
.the_recruit_window_title {
  font-size: 14px;
  text-align: center;
  background-image: linear-gradient(45deg, #6859ea 0, #6acbe0 100%);
  padding: 10px 15px;
  color: #fff;
}
.the_recruit_window_content {
  padding: 15px;
  min-height: 135px;
  line-height: 32px;
}
.the_recruit_window_content a {
  color: #367ce4;
}
@media (max-width: 1200px) {
  .the_recruit_top_menu_row {
    display: none;
  }
  .the_recruit_top_menu_body {
    min-height: auto;
  }
  .the_recruit_h2 {
    font-size: 22px;
  }
  .the_recruit_window_body {
    margin-bottom: 20px;
  }
  .the_recruit_window_body:last-child {
    margin-bottom: 0px;
  }
}
@media (max-width: 1000px) {
  .the_recruit_top_menu_row {
    display: none;
  }
  .the_recruit_top_menu_body {
    min-height: auto;
  }
  .the_recruit_h2 {
    font-size: 18px;
  }
  .the_recruit_window_body {
    margin-bottom: 20px;
  }
  .the_recruit_window_body:last-child {
    margin-bottom: 15px;
  }
}
@media (max-width: 1400px) {
  .the_recruit_body {
    padding-top: 0px;
  }
  .the_recruit_box {
    padding-bottom: 30px;
  }
  .the_recruit_tite_img_body {
    padding-top: 50px;
  }
}
@media (max-width: 768px) {
  .the_recruit_body {
    margin-top: 20px;
  }
}
</style>
